import { z } from 'zod';

export const goalEvolutionPointSchema = z.object({
  ano: z.number(),
  pontuacao: z.number(),
});

export const goalEvolutionSeriesSchema = z.object({
  nome: z.string(),
  dados: z.array(goalEvolutionPointSchema),
});

export type GoalEvolutionPoint = z.infer<typeof goalEvolutionPointSchema>;

export type GoalEvolutionSeries = z.infer<typeof goalEvolutionSeriesSchema>;

export const goalEvolutionResponseSchema = z.object({
  series: z.array(goalEvolutionSeriesSchema),
  interpretacao: z.string().nullish(),
});

export type GoalEvolutionResponse = z.infer<typeof goalEvolutionResponseSchema>;
